module.exports = __webpack_public_path__ + "static/media/game-display-4.0673d21f.png";